class LetoilePromotionListing {
  constructor(root = document) {
    this.roots = [...root.querySelectorAll('[data-promotion-page][data-promotion-collection-url]')]
      .filter((section) => !section.dataset.promotionRemoteListingBound);

    this.roots.forEach((section) => {
      section.dataset.promotionRemoteListingBound = 'true';
      this.bind(section);
    });
  }

  bind(section) {
    const collectionUrl = new URL(section.dataset.promotionCollectionUrl, window.location.origin);
    const promotionUrl = new URL(window.location.href);
    promotionUrl.search = '';
    let requestController;

    const rewriteListingUrl = (value) => {
      const target = new URL(value, window.location.origin);
      if (target.pathname !== collectionUrl.pathname) return value;
      target.pathname = promotionUrl.pathname;
      return `${target.pathname}${target.search}${target.hash}`;
    };

    const prepareRemoteListing = (remotePlp) => {
      const remoteFacets = remotePlp.querySelector('[data-responsive-facets]');
      const remoteResults = remotePlp.querySelector('.le-plp__results');
      if (!remoteResults) return null;

      remoteResults.querySelector('.le-plp__empty')?.remove();
      remoteResults.querySelectorAll('a[href]').forEach((link) => {
        link.setAttribute('href', rewriteListingUrl(link.getAttribute('href')));
      });
      remoteResults.querySelectorAll('form[action]').forEach((form) => {
        form.setAttribute('action', promotionUrl.pathname);
      });

      if (remoteFacets) {
        remoteFacets.querySelectorAll('a[href]').forEach((link) => {
          link.setAttribute('href', rewriteListingUrl(link.getAttribute('href')));
        });
        remoteFacets.querySelectorAll('form').forEach((form) => {
          form.setAttribute('action', promotionUrl.pathname);
        });
      }

      return { remoteFacets, remoteResults };
    };

    const applyRemoteListing = ({ remoteFacets, remoteResults }) => {
      const currentBody = section.querySelector('.le-promo__body');
      const currentFacets = section.querySelector('[data-responsive-facets]');
      const currentResults = section.querySelector('.le-plp__results');
      if (!currentBody || !currentResults) return false;

      if (remoteFacets) {
        const importedFacets = document.importNode(remoteFacets, true);
        if (currentFacets) {
          currentFacets.replaceWith(importedFacets);
        } else {
          currentBody.prepend(importedFacets);
        }
        currentBody.classList.remove('le-plp__body--no-facets');
        section.classList.remove('le-plp--filters-hidden');
      }

      currentResults.replaceWith(document.importNode(remoteResults, true));
      section.removeAttribute('data-le-plp-bound');
      section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      return true;
    };

    const loadListing = async (targetUrl, historyMode = 'replace') => {
      requestController?.abort();
      requestController = new AbortController();
      section.setAttribute('aria-busy', 'true');

      const sourceUrl = new URL(collectionUrl);
      sourceUrl.search = targetUrl.search;

      try {
        const response = await fetch(sourceUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: requestController.signal,
        });
        if (!response.ok) return;

        const html = await response.text();
        const remoteDocument = new DOMParser().parseFromString(html, 'text/html');
        const remotePlp = remoteDocument.querySelector('[data-le-plp]');
        const preparedListing = remotePlp ? prepareRemoteListing(remotePlp) : null;
        if (!preparedListing || !applyRemoteListing(preparedListing)) return;

        const nextPromotionUrl = new URL(promotionUrl);
        nextPromotionUrl.search = targetUrl.search;
        if (historyMode === 'push') {
          window.history.pushState({ promotionListing: true }, '', nextPromotionUrl);
        } else if (historyMode === 'replace') {
          window.history.replaceState({ promotionListing: true }, '', nextPromotionUrl);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          section.dispatchEvent(new CustomEvent('letoile:promotion-listing-error', { bubbles: true }));
        }
      } finally {
        if (!requestController.signal.aborted) section.removeAttribute('aria-busy');
      }
    };

    section.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-collection-filter-form], [data-collection-sort-form]');
      if (!form || !section.contains(form)) return;
      event.preventDefault();

      const nextUrl = new URL(promotionUrl);
      const formData = new FormData(form);
      for (const [key, value] of formData) {
        if (String(value).trim() !== '') nextUrl.searchParams.append(key, value);
      }
      loadListing(nextUrl, 'push');
    }, true);

    section.addEventListener('click', (event) => {
      const link = event.target.closest(
        '[data-active-filter-chip], [data-active-filter-clear], .le-plp__load-more, .le-pagination a',
      );
      if (!link || !section.contains(link)) return;
      event.preventDefault();
      loadListing(new URL(link.href, window.location.origin), 'push');
    }, true);

    window.addEventListener('popstate', () => loadListing(new URL(window.location.href), 'none'));
    loadListing(new URL(window.location.href));
  }
}

new LetoilePromotionListing();
document.addEventListener('shopify:section:load', (event) => new LetoilePromotionListing(event.target));
